<template>
  <div>
    <label class="control-label">{{ node.name }}({{ node.nodeId }})</label>
    <!-- 自定义帮助help -->
    <div class="form-inline">
      <div class="control-label left-label">AI审核点:</div>
      <eco-input style="width: 55%" type="textarea" v-model="propertie.aiAuditPoint" :maxlength="maxlength"></eco-input>
      <br />
    </div>
  </div>
</template>

<script>
const FlowNodeHelp = () => import('@/components/flow/FlowNodeHelp.vue')
export default {
  name: 'FlowNodeAttributes',
  components: { FlowNodeHelp },
  props: {
    //任务节点信息
    node: {
      type: Object,
      required: true
    },
    //节点属性批量勾选配置
    nodeAttr: {
      type: Object,
      required: true
    },
    //流程配置信息
    defConfigData: {
      type: Object,
      required: true
    }
  },
  watch: {
    propertie: {
      handler(newValue, oldValue) {
        let path = 'nodeSetData.bpmDefSetting.nodePropertieMap.' + this.node.nodeId
        let obj = {}
        obj[path] = newValue
        //更新vuex里面defConfigData配置数据
        this.$store.dispatch('flow/updateConfig', obj)
      },
      deep: true
    },
    nodePropertieMap: {
      handler(newValue, oldValue) {
        //更新vuex里面defConfigData配置数据
        this.$store.dispatch('flow/updateConfig', {
          'nodeSetData.bpmDefSetting.nodePropertieMap': newValue
        })
      },
      deep: true
    },
    nodeAttr: {
      handler(newValue, oldValue) {
        this.propertie.jumpType = newValue.jumpType //批量勾选跳转类型
        this.propertie.notifyType = newValue.notify //批量勾选通知类型
        if (newValue.backMode_all != '' && this.node.type != 'signTask') {
          this.propertie.backMode = 'direct' //批量勾选驳回后返回
        } else {
          this.propertie.backMode = 'normal'
        }
        if (newValue.skipExecutorEmpty_all != '') {
          this.propertie.skipExecutorEmpty = true //批量勾选执行人为空时跳过
        } else {
          this.propertie.skipExecutorEmpty = false
        }
      },
      deep: true
    }
  },
  data() {
    return {
      value: '', //帮助内容
      title: '', //帮助弹框标题
      approvalArea: [{ key: 'processRecord', value: '处理记录' }], //审批区域显示
      propertie: {
        aiAuditPoint: ''
      }, //单个节点的配置信息
      selectNodeList: [], //可驳回的节点
      nodePropertieMap: {},
      maxlength: 300
    }
  },
  mounted() {
    this.propertie = this.defConfigData.nodeSetData.bpmDefSetting.nodePropertieMap[this.node.nodeId] //获取单个节点的配置信息
    //获取可驳回节点
    for (let i = 0; i < this.defConfigData.nodeSetData.nodes.length; i++) {
      if (
        this.defConfigData.nodeSetData.nodes[i].type == 'signTask' ||
        this.defConfigData.nodeSetData.nodes[i].type == 'userTask' ||
        this.defConfigData.nodeSetData.nodes[i].type == 'callActivity'
      ) {
        this.selectNodeList.push(this.defConfigData.nodeSetData.nodes[i])
      }
    }
  }
}
</script>

<style lang="scss" scoped>
>>> label.el-radio-horizontal {
  margin: 5px 10px 0 0;
}
>>> label.el-checkbox {
  margin: 5px 10px 0 0;
}
.ht {
  float: left;
  width: 70%;
}
.form-inline {
  float: left;
  width: 100%;
}
.left-label {
  width: 24%;
  float: left;
}
.control-label {
  word-break: break-all;
  text-align: right;
  color: #545252;
  font-size: 12px;
  padding: 0px 10px !important;
  font-weight: bold;
  line-height: 35px;
}
div >>> .box-card {
  margin-bottom: 20px;
}

div >>> .box-card .clearfix {
  padding-top: 20px;
}

div >>> .el-collapse-item__header {
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  font-weight: bold;
}

div >>> .el-button {
  padding: 7px;
  margin-right: 10px;
  margin-left: 0px !important;
}
</style>
